import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const removeKbArticleFromCategory = createAsyncThunk(
  'removeKbArticleFromCategory/removeKbArticleFromCategory',
  async ({ articleId, categoryId, group_id }, { getState, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;

      const url = `${ROOT_URL}/kb/article/${articleId}/category/${categoryId}/remove`;

      const response = await axios.patch(
        url,
        { group_id },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      return {
        articleId,
        categoryId,
        message: response.data?.message,
      };
    } catch (error) {
      console.error('Error removing article from category:', error);
      return rejectWithValue(
        error.response?.data?.message || 'Failed to remove article from category'
      );
    }
  }
);

const initialState = {
  loading: false,
  error: null,
};

const removeKbArticleFromCategorySlice = createSlice({
  name: 'removeKbArticleFromCategory',
  initialState,
  reducers: {
    clearRemoveKbArticleFromCategory: (state) => {
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(removeKbArticleFromCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeKbArticleFromCategory.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(removeKbArticleFromCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearRemoveKbArticleFromCategory } =
  removeKbArticleFromCategorySlice.actions;
export default removeKbArticleFromCategorySlice.reducer;
